export default function FacebookIcon({ className }: { className?: string }) {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      className={className}
      width='8'
      height='15'
      viewBox='0 0 8 15'
      fill='none'
    >
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M5.1617 4.915V3.622C5.1617 3.429 5.17139 3.278 5.19176 3.172C5.2157 3.05881 5.26263 2.95213 5.32945 2.859C5.41425 2.74679 5.53607 2.67063 5.67176 2.645C5.83079 2.605 6.04121 2.585 6.304 2.585H7.73818V0H5.44485C4.1183 0 3.16606 0.284 2.58618 0.85C2.00727 1.418 1.71733 2.255 1.71733 3.358V4.914H0V7.5H1.71733V15H5.1617V7.5H7.45503L7.75758 4.915H5.1617Z'
        fill='currentColor'
      />
    </svg>
  );
}
